module.exports = __webpack_public_path__ + "img/female.65ffd039.svg";